import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutMissionVision() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { ref: missionRef, isVisible: missionVisible } = useScrollAnimation();
  const { ref: visionRef, isVisible: visionVisible } = useScrollAnimation();

  return (
    <section className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={headRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-3 py-1 bg-amber-50 border border-amber-200 text-amber-600 text-sm font-semibold uppercase tracking-widest rounded mb-5">
            Purpose & Direction
          </span>
          <h2 className="text-4xl sm:text-5xl font-semibold text-slate-900 leading-tight">
            Mission & Vision
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Mission */}
          <div
            ref={missionRef as React.RefObject<HTMLDivElement>}
            className={`relative bg-white rounded-2xl p-10 shadow-sm border border-slate-100 overflow-hidden group hover:shadow-md transition-all duration-700 ${missionVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <div className="absolute top-0 left-0 w-1 h-full bg-amber-500 rounded-l-2xl"></div>
            <div className="w-14 h-14 flex items-center justify-center bg-amber-50 rounded-xl mb-6">
              <i className="ri-focus-3-line text-amber-500 text-2xl"></i>
            </div>
            <h3 className="text-3xl font-semibold text-slate-900 mb-4">Our Mission</h3>
            <p className="text-lg text-slate-600 leading-relaxed mb-4">
              To empower businesses operating in regulated industries by providing transparent, efficient, and expert-led corporate consulting services&nbsp; from license acquisition to full compliance management.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              We are committed to removing the barriers that slow businesses down, offering practical solutions that are grounded in deep regulatory knowledge and a genuine understanding of our clients' goals.
            </p>
          </div>

          {/* Vision */}
          <div
            ref={visionRef as React.RefObject<HTMLDivElement>}
            className={`relative bg-white rounded-2xl p-10 shadow-sm border border-slate-100 overflow-hidden group hover:shadow-md transition-all duration-700 delay-150 ${visionVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}
          >
            <div className="absolute top-0 left-0 w-1 h-full bg-slate-900 rounded-l-2xl"></div>
            <div className="w-14 h-14 flex items-center justify-center bg-slate-100 rounded-xl mb-6">
              <i className="ri-eye-line text-slate-900 text-2xl"></i>
            </div>
            <h3 className="text-3xl font-semibold text-slate-900 mb-4">Our Vision</h3>
            <p className="text-lg text-slate-600 leading-relaxed mb-4">
              To become the most trusted corporate consulting and license marketplace in the world a platform where regulated businesses can find every solution they need, from day one to full operational maturity.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              We envision a future where compliance is not a burden but a competitive advantage, and where every business regardless of size&nbsp; has access to world-class advisory expertise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
